import { Component, OnInit, Input } from '@angular/core';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'hybse-admin-nem-test',
  templateUrl: './nem-test.component.html',
  styleUrls: ['./nem-test.component.css']
})
export class NemTestComponent implements OnInit {
  @Input() testAddress: any;
  @Input() nemAddress: any;

  public testList: any;
  public nemList: any;


  constructor(private _url: ApiurlsService, private _req: ApirequestService) { }

  ngOnInit() {
    if (this.testAddress || this.nemAddress) {
      this.getNumAddress();
      this.getTestAddress();
    }
  }
  public getTestAddress(): void {
    const data = { address: this.testAddress };
    this._req.fetchApiData(environment.testUrl, data, 'get').subscribe(
      (response: any) => {
        this.testList = response.data;
        console.log(this.testList);
      },
      err => { },
      () => { });

  }
  public getNumAddress(): void {
    const data = { address: this.nemAddress };
    this._req.fetchApiData(environment.nemUrl, data, 'get').subscribe(
      (response: any) => {
        this.nemList = response.data;
        console.log(this.nemList);
      },
      err => { },
      () => { });
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/nem-test/nem-test.component.ts